type NumberFormatter = (v: number) => string;

const Max2DecimalsFormat = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const Max2Decimals: NumberFormatter = (v: number) => Max2DecimalsFormat.format(v);
